// extracted by mini-css-extract-plugin
module.exports = {"actions":"actions-eSRdz","action":"action-1TIHP","label":"label-1yCrY","disabled":"disabled-3qC7J"};